import type { ReactNode } from 'react';
import { PaperclipIcon } from '@phosphor-icons/react';
import { EmailToggleButton } from './email-toggle-button';

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
};
const TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
};

export function CollapsedEmailSummary({
  subject,
  from,
  receivedAt,
  attachmentCount,
  onToggle,
}: {
  subject: ReactNode;
  from: string | null;
  receivedAt: Date;
  attachmentCount: number;
  onToggle: () => void;
}) {
  return (
    <>
      <div className="flex items-baseline justify-between gap-2">
        <span className="font-medium text-sm truncate">{subject}</span>
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-xs text-muted-foreground">
            {receivedAt.toLocaleDateString([], DATE_FORMAT_OPTIONS)}{' '}
            {receivedAt.toLocaleTimeString([], TIME_FORMAT_OPTIONS)}
          </span>
          <EmailToggleButton isExpanded={false} onToggle={onToggle} />
        </div>
      </div>
      <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5">
        <span className="truncate">{from}</span>
        {attachmentCount > 0 && (
          <>
            <span>-</span>
            <div className="flex items-center gap-1">
              <PaperclipIcon size={10} />
              <span>{attachmentCount}</span>
            </div>
          </>
        )}
      </div>
    </>
  );
}
